import throttle from 'lodash.throttle';

const dragToScroll = (itemsDOM) => {
  let startX;
  let scrollLeft;
  let isMouseDown = false;

  itemsDOM.addEventListener('mousedown', setupScroll);
  itemsDOM.addEventListener('mouseleave', finishScroll);
  itemsDOM.addEventListener('mouseup', finishScroll);
  itemsDOM.addEventListener('mousemove', scroll);

  function setupScroll(e) {
    isMouseDown = true;
    itemsDOM.classList.add('active');
    startX = e.pageX - itemsDOM.offsetLeft;
    scrollLeft = itemsDOM.scrollLeft;
  }

  function finishScroll(e) {
    isMouseDown = false;
    itemsDOM.classList.remove('active');
  }

  function scroll(e) {
    if (!isMouseDown) {
      return;
    }
    e.preventDefault();

    const currentX = e.pageX - itemsDOM.offsetLeft;
    const distanceTravelled = (currentX - startX) * 4;
    itemsDOM.scrollLeft = scrollLeft - distanceTravelled;
  }
};

const markElementsRelativeFromCurrentCenteredView = (
  context,
  selector,
  orientation,
) => {
  if (orientation !== 'horizontal' && orientation !== 'vertical') {
    throw new Error(`Orientation must have the value 'vertical' or 'horizontal'`);
  }
  context.querySelectorAll(selector).forEach((li, i) => {
    let center =
      orientation === 'vertical'
        ? li.parentElement.clientHeight
        : li.parentElement.clientWidth;
    let offset = orientation === 'vertical' ? li.offsetTop : li.offsetLeft;
    let scroll =
      orientation === 'vertical'
        ? li.parentElement.scrollTop
        : li.parentElement.scrollLeft;
    let size = orientation === 'vertical' ? li.clientHeight : li.clientWidth;
    let offsetPositionFromCenter = (center - size) / 2 - (offset - scroll);
    li.dataset.offsetCenter = String(Math.abs(offsetPositionFromCenter));
    li.classList.remove('center');
    delete li.dataset.offset;
  });
  let closestOffset = Math.min(
    ...[...context.querySelectorAll(selector)].map(
      (el) => el.dataset.offsetCenter,
    ),
  );
  let closest = context.querySelector(
    `${selector}[data-offset-center="${closestOffset}"]`,
  );
  closest.classList.add('center-item');

  let updateDatasetOnItem = (item, i) => {
    item.dataset.offsetFromCenter = String(i);
    item.dataset.positionFromCenter = String(-1 * i);

  }

  // mark offsets
  let current = closest;


  if ((Number(current.dataset.offsetCenter) <= 1) && current.classList.contains('center-item')) {
    current.dataset.positionFromCenter = current.dataset.offsetFromCenter = '0';
  }

  let i = 0;
  while (current.previousElementSibling) {
    i++;
    current = current.previousElementSibling;
    updateDatasetOnItem(current, i);
  }

  current = closest;
  i = 0;
  while (current.nextElementSibling) {
    current = current.nextElementSibling;
    i++;
    updateDatasetOnItem(current, i);
  }

  return closest;
};

/**
 * Example CSS:
 *
 * ul {
      display: flex;
      flex-wrap: nowrap;
      overflow: scroll; // no overflow-x or overflow-y!!
      scroll-snap-type: x mandatory;
   }
 */

const scrollToCenter = (el) => {
  el.scrollIntoView({
    behavior: 'smooth',
    inline: 'center',
    block: 'nearest',
  });
};

const scrollToCenterOnClick = (el) => {
  el.addEventListener('click', () => scrollToCenter(el));
};

const markElementsRelativeFromCurrentCenteredViewOnScrollThrottled = (
  context,
  selector,
  orientation,
) => {
  // initial
  markElementsRelativeFromCurrentCenteredView(
    context,
    selector,
    orientation,
  );
  context.addEventListener(
    'scroll',
    throttle((ev) => {
      markElementsRelativeFromCurrentCenteredView(
        context,
        selector,
        orientation,
      );
    }, 0),
  );
};

export {
  markElementsRelativeFromCurrentCenteredView,
  markElementsRelativeFromCurrentCenteredViewOnScrollThrottled,
  scrollToCenter,
  scrollToCenterOnClick,
};
